import styled from "styled-components";

const ActiveFilterButton = styled.button`
  border-radius: 4px;
  border: solid 1px #e6e8f0;
  background-color: #f4f5f8;
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #6f7582;
  transition: all 300ms ease-out;
  text-transform: capitalize;

  :hover {
    border-color: #ccd2e1;
    img {
      background-color: #dce0ea;
    }
  }
`;

const IconClose = styled.img`
  padding: 4px;
  border-radius: 50%;
  background-color: #e6e8f0;
  transition: all 300ms ease-out;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: inline-block;
  }
  span {
    margin-right: 4px;
  }
`;

export { ActiveFilterButton, IconClose, Content };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/activeFilters/ActiveFilterStyle.js